 (function () {
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()
      }
    }
    insertSectionCartPage() */

    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    // NOTE: this observer used to re-trigger itself forever — every DOM change it made
    // (moving nodes, replacing the upsell wrapper) was itself picked up by the same
    // observer, which fetched the whole page again and mutated the DOM again, in an
    // infinite loop (hundreds of requests per page view). Fix: disconnect the observer
    // while we make our own changes, and guard against re-entrancy.
    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return

      let timer
      let isUpdating = false

      const observer = new MutationObserver((mutations) => {
        if (isUpdating) return
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          isUpdating = true
          observer.disconnect()

          try {
            const respoonse = await fetch(window.location.href)
            const text = await respoonse.text()
            const newDocument = new DOMParser().parseFromString(text, 'text/html')

            const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper')
            const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper')
            if (currentWrapper && newWrapper) {
              currentWrapper.replaceWith(newWrapper)
            }

            insertSectionCartDrawer()
          } finally {
            isUpdating = false
            observer.observe(element, {
              attributes: true,
              childList: true,
              subtree: true
            })
          }
        }, 250)
      })

      observer.observe(element, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      let isUpdating = false

      const observer = new MutationObserver((mutations) => {
        if (isUpdating) return
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          isUpdating = true
          observer.disconnect()

          try {
            const respoonse = await fetch(window.location.href)
            const text = await respoonse.text()
            const newDocument = new DOMParser().parseFromString(text, 'text/html')

            const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper')
            const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper')
            if (currentWrapper && newWrapper) {
              currentWrapper.replaceWith(newWrapper)
            }
          } finally {
            isUpdating = false
            observer.observe(element, {
              attributes: true,
              childList: true,
              subtree: true
            })
          }
        }, 250)
      })

      observer.observe(element, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
    listenCartPage()
  })();
